import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {elevation, colors} from '@atlaskit/theme';
import dateformat from 'dateformat';
import Lozenge from '@atlaskit/lozenge';
import EmojiFrequentIcon from '@atlaskit/icon/glyph/emoji/frequent';
import {GridColumn} from '@atlaskit/page';
import {Trans} from 'react-i18next';

const Container = styled.div`
  ${elevation['e100']}
  background-color: white;
  border-radius: 3px;
  margin-bottom: 8px;
  min-width: 260px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const NameWrapper = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  color: #172B4D;
  justify-content: space-between;
  
`;
const DescriptionWrapper = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #6B778C;
`;

const DateWrapper = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #6B778C;
  align-items: center;
  display: flex;
`;

const ErrorWrapper = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #172B4D;
`;



export default class DiagnosticListItem extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    state: PropTypes.string,
    description: PropTypes.string,
    time: PropTypes.any,
    error: PropTypes.string,
  };
    
  render() {
    const {
      name,
      state,
      description,
      time,
      error,
      t,
    } = this.props;
    
    return (
      <Container>
        <NameWrapper>
          {name}
          <div>
            <Lozenge
              isBold={true}
              appearance={state && STATE_APPEARANCE[state] ? STATE_APPEARANCE[state] : STATE_APPEARANCE.NONE}
            >
              <Trans ns='diagnostic'>{state}</Trans>
            </Lozenge>
          </div>
        </NameWrapper>
        <DescriptionWrapper>{description}</DescriptionWrapper>
        <DateWrapper>
          <EmojiFrequentIcon size='small'/>
          {dateformat(time, 'dd.mm.yyyy HH:MM')}
        </DateWrapper>
        {error && (
          <ErrorWrapper>
            {error}
          </ErrorWrapper>
        )}
      </Container>
    );
  }
}

const STATE_APPEARANCE = {
  NONE: 'default',
  SUCCESS: 'success',
  WARNING: 'inprogress',
  ERROR: 'removed',
  INFO: 'new',
}